<form (ngSubmit)="changePassword()" [formGroup]="recoverPasswordForm"
      class="login-form form-change-password login-view-2">
  <h3 class="login-form-header">{{ 'login.update_password' | translate }}</h3>
  <div class="login-form-subheader">
    <span>{{ 'login.for' | translate }} </span>{{ getUsername() }}
  </div>

  <div class="form-group is-invalid change-password">
    <div class="login-password">
      <app-input-regular
        [controlForm]="recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD]"
        [displayErrorDynamic]="displayErrorDynamic"
        [label]="'login.new_password'"
        [typeInput]="'password'"
        id="new-password">
      </app-input-regular>
      <app-input-regular
        [controlForm]="recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.CONFIRM_PASSWORD]"
        [displayErrorDynamic]="displayErrorDynamic"
        [label]="'login.confirm_password'"
        [typeInput]="'password'">
      </app-input-regular>
    </div>

    <div class="check-password" *ngIf="passwordSecurity">
      <div class="password-verifications-header">{{ 'login.password_must_have' | translate }}</div>

      <div *ngIf="passwordSecurity.length > 0" class="password-verifications"
           [ngClass]="{'password-verifications-ok': recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD]?.value?.length >= passwordSecurity.length}">
        <div class="icon-secure"
             [ngClass]="{'icon-secure-ok': recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD]?.value?.length >= passwordSecurity.length}">
        </div>
        {{ 'login.8_or_more_characters' | translate: {number: passwordSecurity.length} }}
      </div>

      <div *ngIf="passwordSecurity.lowerCaseMin > 0" class="password-verifications"
           [ngClass]="{'password-verifications-ok': passwordService.checkLowerCase(passwordSecurity, recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD].value)}">
        <div class="icon-secure"
             [ngClass]="{'icon-secure-ok': passwordService.checkLowerCase(passwordSecurity, recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD].value)}">
        </div>
        {{ 'login.at_least_one_lowercase' | translate: {number: passwordSecurity.lowerCaseMin} }}
      </div>

      <div *ngIf="passwordSecurity.upperCaseMin > 0" class="password-verifications"
           [ngClass]="{'password-verifications-ok': passwordService.checkUpperCase(passwordSecurity, recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD].value)}">
        <div class="icon-secure"
             [ngClass]="{'icon-secure-ok': passwordService.checkUpperCase(passwordSecurity, recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD].value)}">
        </div>
        {{ 'login.at_least_one_uppercase' | translate: {number: passwordSecurity.upperCaseMin} }}
      </div>

      <div *ngIf="passwordSecurity.numericalMin > 0" class="password-verifications"
           [ngClass]="{'password-verifications-ok': passwordService.checkNumber(passwordSecurity, recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD].value)}">
        <div class="icon-secure"
             [ngClass]="{'icon-secure-ok': passwordService.checkNumber(passwordSecurity, recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD].value)}">
        </div>
        {{ 'login.at_least_one_number' | translate: {number: passwordSecurity.numericalMin} }}
      </div>

      <div *ngIf="passwordSecurity.specialMin > 0" class="password-verifications"
           [ngClass]="{'password-verifications-ok': passwordService.checkSpecial(passwordSecurity, recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD].value)}">
        <div class="icon-secure"
             [ngClass]="{'icon-secure-ok': passwordService.checkSpecial(passwordSecurity, recoverPasswordForm.controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD].value)}">
        </div>
        {{ 'login.at_least_one_special' | translate: {number: passwordSecurity.specialMin} }}
      </div>
    </div>
  </div>

  <div class="login-errors">
    <div *ngIf="getError(); let error">{{ error }}</div>
  </div>

  <div class="login-button-container">
    <div class="grey-button" (click)="cancel.emit()">{{ 'login.cancel' | translate }}</div>
    <app-button [label]="'common.dialog.save'"></app-button>
  </div>
</form>
